export const getLatestStock = async ({ axios } = {}) => {
  try {
    return await (axios || $nuxt.$axios).get(`/get/stocks/latest`);
  } catch (error) {
    return { error: error.response?.data || error };
  }
};

export const getOldStocks = async (payload) => {
  try {
    return await $nuxt.$axios.get(
      `get/stocks/old?page=${payload.page}&pageSize=${payload.pageSize}`
    );
  } catch (error) {
    return { error: error.response?.data || error };
  }
};
